import React from 'react';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
type Tone = 'light' | 'dark';
export function CarouselControls({
  onPrev,
  onNext,
  tone = 'light',
  className = ''
}: {
  onPrev: () => void;
  onNext: () => void;
  tone?: Tone;
  className?: string;
}) {
  const base = tone === 'dark' ? 'border-polar/25 text-polar hover:border-caribe hover:text-caribe' : 'border-oceano/15 text-oceano hover:border-caribe hover:text-caribe';
  return <div className={`flex gap-2 ${className}`} data-id="element-180" data-mp="2q7blx0t51r9p">
      <button type="button" aria-label="Ver anterior" onClick={onPrev} className={`flex h-10 w-10 items-center justify-center rounded-full border transition-colors duration-150 ease-out ${base}`} data-id="element-181" data-mp="2v4k2wy2jvp9d">
        <ChevronLeftIcon className="h-4 w-4" aria-hidden="true" data-id="element-182" data-mp="2m2u2j2qoxfzg" />
      </button>
      <button type="button" aria-label="Ver siguiente" onClick={onNext} className={`flex h-10 w-10 items-center justify-center rounded-full border transition-colors duration-150 ease-out ${base}`} data-id="element-183" data-mp="fdfghyauxiuk">
        <ChevronRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-184" data-mp="k5mfry8foky5" />
      </button>
    </div>;
}
export function CarouselDots({
  count,
  activeIndex,
  tone = 'light',
  className = ''
}: {
  count: number;
  activeIndex: number;
  tone?: Tone;
  className?: string;
}) {
  const inactive = tone === 'dark' ? 'bg-polar/25' : 'bg-oceano/15';
  return <div className={`flex items-center gap-2 ${className}`} aria-hidden="true" data-id="element-185" data-mp="ox4f6hut6dh0">
      {Array.from({
      length: count
    }).map((_, index) => <span key={index} className={`h-[3px] rounded-full transition-[width,background-color] duration-200 ease-out ${index === activeIndex ? 'w-7 bg-caribe' : `w-3 ${inactive}`}`} data-id="element-186" data-mp="3tassp7csxfyr" data-mpi={index} />)}
    </div>;
}